// 商品-创建
export default {
    tabel_title: "商品列表",
    tl_shopImg: "商品图片",
    tl_shopName: "商品名称",
    tl_price_serial: "价格/货号",
    tr_price: "价格:",
    tr_serial: "货号:",
    tl_specName: "属性",
    tl_number: "数量",
    tl_quantity: "库存",
    tl_amount: "小计",
    statistical_desc: "件商品 订单合计：",

    // 新增商品
    dt_addGoods: "新增商品",
    dl_search: "搜索商品",
    dp_search: "请输入商品名称/货号",
    btn_search: "搜索",
    dl_category: "分类",
    dp_category: "请选择分类",
    dl_goodsName: "商品名称",
    dp_goodsName: "请选择商品",
    tag_new: "上线",
    tag_promotion: "促销",
    tag_hot: "热销",
    tag_recommend: "推荐",
    dl_goodsSerial: "商品货号",
    dl_brand: "品牌",
    dl_price: "价格",
    dl_specs: "属性",
    dp_specs: "请选择",
    dl_quantity: "库存",
    dl_number: "数量",
    dp_number: "请输入",
    btn_addItem: "加入订单"
};
